import { render, staticRenderFns } from "./dashboardfleet.vue?vue&type=template&id=6a00df37"
import script from "./dashboardfleet.vue?vue&type=script&lang=js"
export * from "./dashboardfleet.vue?vue&type=script&lang=js"
import style0 from "./dashboardfleet.vue?vue&type=style&index=0&id=6a00df37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports